// extracted by mini-css-extract-plugin
export var buttons = "_ao-0";
export var buttonsActive = "_ao-h";
export var cancelConfirm = "_ao-1";
export var closeButton = "_ao-2";
export var column = "_ao-3";
export var container = "_ao-4";
export var detailHeader = "_ao-6";
export var detailTitle = "_ao-7";
export var detailsContent = "_ao-5";
export var header = "_ao-8";
export var headerWithClose = "_ao-9";
export var icon = "_ao-a";
export var infoIcon = "_ao-c";
export var informationContainer = "_ao-b";
export var sideDrawer = "_ao-d";
export var sideDrawerOpen = "_ao-e";
export var stickyFooter = "_ao-f";
export var typeOption = "_ao-g";